import React, { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { IAudioLink } from '../../../../dataObjects/models/digitalMedia/AudioLink';
import { listViewStyles } from '../../../styles';
import AudioLinksListViewItem from './AudioLinksListViewItem';
import { IAudioLinkViewModel } from '../../../../dataObjects/viewModels/audioLinkViewModel';


export interface IAudioLinksListViewProps extends PropsWithChildren<unknown> {
  audioLinkViewModels: Array<IAudioLinkViewModel>;
  onDelete: (AudioLink: IAudioLink) => void;
}

export const AudioLinksListView: React.FC<IAudioLinksListViewProps> = (props: IAudioLinksListViewProps) => {
  AudioLinksListView.displayName = 'AudioLinks List View';

  // eslint-disable-next-line no-console
  // console.info(`Render AudioLinksListView`);

  const classes: Record<string, string> = listViewStyles();

  const { audioLinkViewModels, onDelete } = props;

  return (
    <>
      {/* overall grid for list. There will be a header row and either one or two data rows, based on a media query: 
          - Header Row
          - Data Row 1: Audio & Action Buttons (also, the Description for larger screen sizes)
          - Data Row 2: Description (this row is only shown for smaller screen sizes)
      */}
      <Grid container direction="column" >
        {/* Header Row */}
        <Grid key='tableHeader' container className={classes.tableHeader} size={12} direction="row">
          <Grid key='nameAndDescriptionLabel' size={{ xs: 10, sm: 12, md: 10 }} >
            <Typography variant='h6'>
              Audio / Description
            </Typography>
          </Grid>
          <Grid container size={{ md: 2 }} direction="row" justifyContent="center" alignContent="flex-start">
            <Grid key='editLabel' container className={classes.actionButtonLabelContainer} size={{ md: 6 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Edit
                </Typography>
              </Box>
            </Grid>
            <Grid key='deleteLabel' container className={classes.actionButtonLabelContainer} size={{ md: 6 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Delete
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {
          audioLinkViewModels.map((audioLinkViewModel, idx) => (
            <AudioLinksListViewItem
              key={audioLinkViewModel.audioLink.id}
              audioLinkViewModel={audioLinkViewModel}
              onDelete={onDelete}
            />
          ))
        }
      </Grid>
    </>
  );
};

export default AudioLinksListView;